<template>
  <div class="stock_details_holder">
    <div class="stock_details_spacer"></div>
    <div v-for="stock in stockData.stock_list" :key="stock.warehouse_uuid">
      <div class="info_line" @click="warehouseClickOnSelectionMode(stockData, stock)">
        <div class="info_value">{{ stock.warehouse_name }}<template v-if="stock.department_name"> ({{ stock.department_name }})</template></div>
        <div class="info_quantity">{{ stock.quantity | getFormattedQuantity }} {{ stockData?.measure_unit?.symbol }}</div>
        <img
          v-if="stockData.lot_management && !selectionMode"
          class="info_image"
          :src="
            isWarehouseExpanded(stock)
              ? require('@/assets/images/icons/arrow_up_green.svg')
              : require('@/assets/images/icons/arrow_down.svg')
          "
          @click.stop="toggleWarehouseLots(stock)"
        />
        <img
          v-else
          class="info_image"
          src="@/assets/images/icons/right_arrow_black.svg"
          @click.stop="productHistoryClick(stockData, stock)"
        />
      </div>
      <div v-show="stockData.lot_management && isWarehouseExpanded(stock)">
        <div class="details_btn_container product_warehouse_details" @click="productHistoryClick(stockData, stock)">
          <div class="product_warehouse_details_left">
            <img src="@/assets/images/icons/details_file.svg" />
            <span>{{ $t("product_warehouse_details_history") }}</span>
          </div>
        </div>
        <StockLotsList
          v-if="stockData.lot_management && !selectionMode"
          :productUuid="stockData.uuid"
          :productName="stockData.name"
          :warehouseUuid="stock.warehouse_uuid"
          :warehouseName="stock.warehouse_name"
          :departmentName="stock.department_name"
          :measureUnitSymbol="stockData?.measure_unit?.symbol"
          :active="isWarehouseExpanded(stock)"
          @openQuickConsum="$emit('openQuickConsum', stockData, stock)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import StockLotsList from "./StockLotsList.vue";

export default {
  name: "StockLocations",
  props: {
    stockData: [],
    selectionMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedWarehouses: {},
    };
  },
  components: {
    StockLotsList,
  },
  methods: {
    isWarehouseExpanded(stock) {
      return !!this.expandedWarehouses[stock.warehouse_uuid];
    },
    toggleWarehouseLots(stock) {
      const nextValue = !this.expandedWarehouses[stock.warehouse_uuid];
      this.$set(this.expandedWarehouses, stock.warehouse_uuid, nextValue);
    },
    warehouseClickOnSelectionMode(stock_data, warehouse) {
      if (this.selectionMode) {
        this.$emit("warehouseClickOnSelectionMode", stock_data, warehouse);
      }
    },
    productHistoryClick(stock_data, warehouse) {
      if (!this.selectionMode) {
        this.$emit("openHistoryDialog", stock_data, warehouse);
      } else {
        this.$emit("warehouseClickOnSelectionMode", stock_data, warehouse);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product_warehouse_details {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product_warehouse_details_left {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
